import { AuthContext } from 'context/authContext';
import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useContext } from 'react';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function useGetFolders(
  id,
  searchFilter,
  yearFilter,
  monthFilter
) {
  const { authState } = useContext(AuthContext);
  const employeeId = authState?.user_id;
  return useQuery(
    ['repository-folders', id, searchFilter, yearFilter, monthFilter],
    async () => {
      const response = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.REPOSITORY_CURD_API, {
          id: id,
          employee_id: !!employeeId ? employeeId : null,
          search: searchFilter,
          created_date__year: yearFilter,
          created_date__month: monthFilter,
        })
      );

      return response.data;
    }
  );
}
